import entry from "./entry.js";

const modal = () => {
    document.querySelectorAll('.js-modal-open').forEach(btn => {
        btn.addEventListener('click', () => {
            const id = btn.dataset.modal;
            document.getElementById(id).classList.add('is-active');
        });
    });

    document.querySelectorAll('.js-modal-close').forEach(btn => {
        btn.addEventListener('click', () => {
            btn.closest('.modal').classList.remove('is-active');
        });
    });
}

const toggle = () => {
    document.querySelectorAll('.js-detail-toggle').forEach(head => {
        head.addEventListener('click', () => {
            const item = head.closest('.js-item');
            const content = item.querySelector('.js-item__content');
            const cursor = head.querySelector('.c-basics-cursor');

            // content 表示切り替え
            content.classList.toggle('is-open');

            // cursor direction 切り替え
            if (cursor) {
                const current = cursor.dataset.direction;
                cursor.dataset.direction = current === 'bottom' ? 'top' : 'bottom';
            }
        });
    });
}
const recruit = () => {
    modal();
    toggle();
    entry();
}
export default recruit
